import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { OSSImageUpload } from './components/upload';
export const CnOSSImageUpload = withI18n(OSSImageUpload, {
    locale,
    componentName: 'CnOSSImageUpload',
    _noHoc: true,
});
